import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tresses_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

export function formatApiError(detail, fallback) {
    if (detail == null) return fallback || "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        const joined = detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : (typeof e === "string" ? e : "")))
            .filter(Boolean)
            .join(" · ");
        return joined || (fallback || "Something went wrong. Please try again.");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    try {
        return String(detail);
    } catch {
        return fallback || "Something went wrong. Please try again.";
    }
}
